/**
 * Configuração de navegação do painel do clube.
 * `when` recebe as flags do ClubContext; omitido = sempre visível.
 */

export const CLUB_NAV_GROUPS = [
    {
        id: 'home',
        items: [
            { to: 'tutorial', label: 'Tutorial', icon: 'Rocket', highlight: true, badgeKey: 'tutorialPending' },
            { to: 'dashboard', label: 'Dashboard', icon: 'LayoutDashboard', end: true },
        ],
    },
    {
        id: 'plans',
        label: 'Planos e assinantes',
        items: [
            {
                to: 'planos',
                label: 'Planos',
                icon: 'Store',
                badgeKey: 'plansPending',
                badgeVariant: 'alert',
                /** reseller = página de vendas; benefit = gestão de benefícios */
                when: caps => caps.isReseller || caps.hasBenefits,
            },
            /** Cadastro de membros — disponível para qualquer clube */
            { to: 'assinantes', label: 'Assinantes', icon: 'Users' },
            {
                to: 'vendas',
                label: 'Vendas',
                icon: 'Receipt',
                /** proprietário, administrador e suporte Eurobem */
                when: caps => caps.isReseller && caps.canViewFinance,
            },
        ],
    },
    {
        id: 'network',
        label: 'Minha rede',
        /** cupons = rede de descontos; vouchers = rede local */
        when: caps => caps.hasCoupons || caps.hasVouchers,
        items: [{ to: 'anunciantes', label: 'Anunciantes', icon: 'Network' }],
    },
    {
        id: 'club',
        label: 'Meu clube',
        items: [
            { to: 'personalizacao', label: 'Personalização', icon: 'Settings', end: true, badgeKey: 'personalizationPending', badgeVariant: 'alert' },
            {
                to: 'revenda',
                label: 'Revenda',
                icon: 'Store',
                /** proprietário, administrador e suporte Eurobem */
                when: caps => (caps.hasBenefits || caps.isReseller) && caps.canViewFinance,
                badgeKey: 'resellerPending',
                badgeVariant: 'alert',
            },
            { to: 'notificacoes', label: 'Notificações', icon: 'Bell' },
        ],
    },
    {
        id: 'account',
        label: 'Minha conta',
        items: [
            { to: 'conta', label: 'Conta', icon: 'CreditCard' },
            { to: 'usuarios', label: 'Equipe', icon: 'Users' },
            {
                href: 'https://clube-eurobem.readme.io/docs/visao-geral',
                label: 'Ajuda',
                icon: 'CircleHelp',
                external: true,
            },
        ],
    },
];

/** Rotas que exigem capability (path relativo a /clube) */
export const CLUB_FEATURE_ROUTES = [
    {
        paths: ['planos'],
        when: caps => caps.isReseller || caps.hasBenefits,
    },
    {
        paths: ['vendas'],
        when: caps => caps.isReseller && caps.canViewFinance,
    },
    {
        paths: ['anunciantes', 'anunciantes/:id'],
        when: caps => caps.hasCoupons || caps.hasVouchers,
    },
    {
        paths: ['revenda'],
        when: caps => (caps.hasBenefits || caps.isReseller) && caps.canViewFinance,
    },
];

export function filterClubNavGroups(groups, caps) {
    return groups
        .filter(group => !group.when || group.when(caps))
        .map(group => ({
            ...group,
            items: group.items.filter(item => !item.when || item.when(caps)),
        }))
        .filter(group => group.items.length > 0);
}

export function clubHasFeatureForPath(pathname, caps) {
    const relative = pathname.replace(/^\/clube\/?/, '').replace(/\/+$/, '');
    if (!relative || relative === 'dashboard') return true;

    const rule = CLUB_FEATURE_ROUTES.find(r =>
        r.paths.some(p => {
            if (p.includes(':')) {
                const [base] = p.split('/');
                return relative === base || relative.startsWith(`${base}/`);
            }
            return relative === p || relative.startsWith(`${p}/`);
        }),
    );

    if (!rule) return true;
    return rule.when(caps);
}
